import styled from 'styled-components';
import React from 'react';
import { TGlobalColors } from '@pb/styles';
import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { Icon } from '@pb/shared/ui/atoms/icon';
import { TStyledValidationNotificationProperties } from './validation-notification.types';

export const StyledValidationNotification = styled.div`
    width: 100%;
`;

export const StyledWrapper = styled.div`
    display: flex;
`;

export const StyledParagraph = styled(
    Paragraph
)<TStyledValidationNotificationProperties>`
    && {
        display: flex;
        margin-top: 0;
        color: ${({ color, theme }) => theme.color[color as TGlobalColors]};
    }
`;

export const StyledIcon = styled(properties => <Icon {...properties} />)`
    && {
        display: flex;
        flex-shrink: 0;
        justify-content: flex-start;
        margin-right: 0.4rem;
    }
`;
